export default "__VITE_ASSET__BDSMZVIi__"